import useIndicesConfiguration from "hooks/useIndicesConfiguration";
const useMaxIndexRotationLimit = () => {
  const { retentionStrategiesContext } = useIndicesConfiguration();
  return retentionStrategiesContext == null ? void 0 : retentionStrategiesContext.max_index_retention_period;
};
export default useMaxIndexRotationLimit;
